import React from 'react'
import { GridContainer, GridItem, Image, Item, List } from './Infographics.styles'

/**
 * The ComparadorProviders component.
 */
const ComparadorProviders = () => (
  <GridContainer padding="0 0 8px">
    <GridItem sm={6} xs={12}>
      <Image alt="Imagen ayuda" src="/assets/images/accordion-examples/Ejemplo-Comparador-Proveedores.svg" />
    </GridItem>
    <GridItem sm={6} xs={12}>
      <List>
        <Item>Selecciona el año que deseas consultar.</Item>
        <Item>
          Selecciona el tipo de distribución que deseas para los datos, monto en pesos, porcentaje o número de órdenes
          de compra.
        </Item>
        <Item>Selecciona el tipo de vista que deseas para los datos, ya sea visualización o tabla de datos.</Item>
        <Item>Eje correspondiente al tipo de distribución seleccionada.</Item>
        <Item>Corresponde a los distintos tipos de proveedores según su tamaño de empresa.</Item>
      </List>
    </GridItem>
  </GridContainer>
)

export default ComparadorProviders
